var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "h100-full flex pad20 flex-column bg-f2" },
    [
      _c("div", { staticClass: "f22 mar20-b lh-1 flex-shrink" }, [
        _vm._v("供应商列表")
      ]),
      _c(
        "div",
        { staticClass: "flex-auto" },
        [
          _c("n-list-generato", {
            attrs: {
              searchData: _vm.searchData,
              theadData: _vm.theadData,
              tbodyData: _vm.tbodyData,
              total: _vm.total,
              pageSize: _vm.pageSize,
              "current-page": _vm.pageNum,
              "page-sizes": [10, 20, 30, 50, 100],
              buttonFunctionData: _vm.buttonFunctionData
            },
            on: {
              "update:currentPage": function($event) {
                _vm.pageNum = $event
              },
              "update:current-page": function($event) {
                _vm.pageNum = $event
              },
              searchSubmit: _vm.searchSubmit,
              "size-change": _vm.sizeChange,
              "current-change": _vm.currentChange,
              buttonFunctionAdd: _vm.supplierCreate,
              buttonFunctionRefresh: _vm.loadData,
              buttonFunctionExport: _vm.handleExport
            },
            scopedSlots: _vm._u([
              {
                key: "fn",
                fn: function(slotProps) {
                  return [
                    _c(
                      "el-popconfirm",
                      {
                        attrs: { title: "确定移除吗？" },
                        on: {
                          confirm: function($event) {
                            return _vm.supplierDel(slotProps.row.id)
                          }
                        }
                      },
                      [
                        _c(
                          "el-link",
                          {
                            attrs: { slot: "reference", type: "primary" },
                            slot: "reference"
                          },
                          [_vm._v("移除")]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-link",
                      {
                        staticClass: "mar10-l",
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.$refs.clearingSetupDrawer.open(
                              slotProps.row.id
                            )
                          }
                        }
                      },
                      [_vm._v("结算设置")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("ShopListDrawer", {
        ref: "shopListDrawer",
        on: { confirm: _vm.supplierConfirm }
      }),
      _c("ClearingSetupDrawer", {
        ref: "clearingSetupDrawer",
        on: { confirm: _vm.clearingSetupConfirm }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }